import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {useEffect, useRef, useState} from 'react';
import { handleSelfi } from '../../../../../reduxToolkit/CompanyEmployees/CompanyEmployeesSlice';
import routes from '../../../../../Routes/routes';
import { permissionObj } from '../../../../../Helpers/permission';
import TableFunction from '../../../../../components/table/TableFunction';
import AllEmployeeDataApp from './AllEmployeeDataApp';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param props
 */
const AllEmployeeCardsApp = (props) => {

    const {
        contractorId,
        supplierId,
        setIsAllChecked,
        setSimpleSearch,
        searchElement,
        selectedList,
        setSelectedList,
        modified,
        setModified,
        finalArray,
        view,
        setCriteria,
        option,
        setBodyForExport
    } = props;

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const elementRef = useRef(null);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [searchResults, setSearchResults] = useState({ content: [], totalElements: 0 } );
    const searchId = 'txt_aeca_search_employees';

    useEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            elementRef.current.style.setProperty('--top-value', `${rect.top}px`);
        }
    }, [searchResults]);

    const handleOnClick = (contractorId, supplierId, item) => {
        dispatch(handleSelfi([]));
        if (contractorId) {
            navigate(item?.periodId ? `${routes.contractor.employeeDocumentation}${item?.userId}`
                : `${routes.contractor.employeeDetails}${item?.userId}`
            );
        } else if (supplierId) {
            navigate(item?.periodId ? `${routes.suppliers.employeeDocumentation}${item?.userId}`
                : `${routes.supplierOrderDetails.orderDetails}${item?.userId}`
            );
        } else {
            // Without the update permission, read-only users open the employee as details
            const canUpdate = DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE);
            navigate(
                `${canUpdate ? routes.employee.edit : routes.employee.employeeDetails}${item?.userId}`
            );
        }
    };

    const {
        getData,
        getDataAdvancedSearch
    } = AllEmployeeDataApp({
        finalArray,
        view,
        setCriteria,
        contractorId,
        supplierId,
        option,
        searchElement,
        setBodyForExport,
        setSearchResults,
        setSimpleSearch
    });


    const {
        t,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: searchResults,
        labelRowsPerPage: 'empolyee_per_page',
        hasContainer: true,
        fixedPagination: false,
        setIsAllChecked,
        view,
        searchElement,//New
        getData,//New
        modified,//New
        setModified,//New
        getDataAdvancedSearch,//New - apply only with advanced search
        finalArray//New - apply only with advanced search
    });


    return {
        searchResults, setSearchResults,
        searchId,
        elementRef,
        handleOnClick,
        DEV,
        permission,
        t,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage
    };

};

export default AllEmployeeCardsApp
